import '../../common/css/style.css';

// • Історія створення та розвиток студії
// • Основні напрямки навчання (дитяча хореографія, бальні танці тощо)
// • Досягнення (нагороди, конкурси, виступи)
// • Місія та цінності

export const AboutStudio = () => {
  return (
    <div id="about" className="main-style">
      <div className="container-wrapper">
        <section className="container">
          <h2 className="container-title">Про студію 📖</h2>

          <section className="container-block">
            <h3 className="container-heading">Наша історія</h3>
            <p>
              <strong>Хореографічна студія «Мрія»</strong> народилась із
              бажання подарувати дітям простір для творчості та руху 🌱 З
              перших днів ми ставимо собі за мету навчати з любовʼю, надихати
              власним прикладом і створювати теплу атмосферу, куди хочеться
              повертатись щодня.
            </p>
          </section>

          <section className="container-block">
            <h3 className="container-heading">Напрямки навчання</h3>
            <ul className="feature-list">
              <li>🧒 Для наймолодших (від 3 років) — основи хореографії через гру та ритм</li>
              <li>💃 Дитяча естрадна та народна хореографія — емоції, пластика, сцена</li>
              <li>🕺 Спортивно-бальні танці — європейська та латиноамериканська програми</li>
            </ul>
          </section>

          <section className="container-block">
            <h3 className="container-heading">Досягнення</h3>
            <p>
              🏆 Наші учні беруть участь у конкурсах, фестивалях і
              танцювальних змаганнях. Кожен виступ — це шанс розкрити свій
              потенціал, повірити в себе та здобути перемогу, якою ми
              пишаємось разом 🎖️
            </p>
          </section>

          <section className="container-block">
            <h3 className="container-heading">Місія та цінності</h3>
            <p>
              ✨ Ми віримо, що танець — це не лише рух, а й виховання
              характеру. Цінуємо щирість, наполегливість і повагу одне до
              одного — і разом творимо красиву історію кожного учня 💛
            </p>
          </section>
        </section>
      </div>
    </div>
  );
};
